import { Action } from '@ngrx/store';
import { Tag } from '../_models/tag.model';
import { QueryParamsModel } from '../../_base/crud';

export enum TagActionTypes {
  TagOnServerCreated = '[Tags] Tag On Server Created',
  TagCreated = '[Tags] Tag Created',
  TagsPageRequested = '[Tags] Tags Page Requested',
  TagsPageLoaded = '[Tags] Tags Page Loaded',
  TagsPageCancelled = '[Tags] Tags Page Cancelled',
  TagsPageToggleLoading = '[Tags] Tags Page Toggle Loading',
  TagsActionToggleLoading = '[Tags] Tags Action Toggle Loading',
  ThrowTagError = '[Tags] Throw Error',
  FireTagSuccess = '[Tags] Fire Success',
}

export class TagOnServerCreated implements Action {
  readonly type = TagActionTypes.TagOnServerCreated;

  constructor(public payload: { tag: Tag }) {}
}

export class TagCreated implements Action {
  readonly type = TagActionTypes.TagCreated;

  constructor(public payload: { tag: Tag }) {}
}

export class ThrowTagError implements Action {
  readonly type = TagActionTypes.ThrowTagError;

  constructor(public payload: { error: any }) {}
}

export class FireTagSuccess implements Action {
  readonly type = TagActionTypes.FireTagSuccess;

  constructor(public payload: { action_type: string }) {}
}

export class TagsPageRequested implements Action {
  readonly type = TagActionTypes.TagsPageRequested;

  constructor(public payload: { page: QueryParamsModel }) {}
}

export class TagsPageLoaded implements Action {
  readonly type = TagActionTypes.TagsPageLoaded;

  constructor(public payload: { tags: Tag[]; totalCount: number; page: QueryParamsModel }) {}
}

export class TagsPageCancelled implements Action {
  readonly type = TagActionTypes.TagsPageCancelled;
}

export class TagsPageToggleLoading implements Action {
  readonly type = TagActionTypes.TagsPageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class TagsActionToggleLoading implements Action {
  readonly type = TagActionTypes.TagsActionToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export type TagActions =
  | TagCreated
  | TagOnServerCreated
  | TagsPageLoaded
  | TagsPageCancelled
  | TagsPageToggleLoading
  | TagsPageRequested
  | ThrowTagError
  | FireTagSuccess
  | TagsActionToggleLoading;
